import { apiSlice } from './apiSlice';

/**
 * Coupons — the codes the back end publishes for traders to use at checkout.
 *
 *   GET /published-coupons/?page=&page_size= → { count, results: [coupon] }
 *
 * A coupon row, as the live Coupons page reads it: `coupon_name` (the code
 * itself), `coupon_percent` or `coupon_amount` (one of the two is the
 * discount), `start_date` / `start_time` and `coupon_expiry` / `expiry_time`
 * (plain dates and times, no offset), `challenges` (`[{ id, name, steps }]`,
 * empty when the code applies to every challenge) and `description`.
 */
export const couponsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPublishedCoupons: builder.query({
      query: (params) => ({
        url: '/published-coupons/',
        params,
      }),
    }),
  }),
});

export const { useGetPublishedCouponsQuery } = couponsApi;
